<template>
  <b-modal :active.sync="active" has-modal-card @close="$emit('close')">
    <div class="card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
      </header>
      <section class="modal-card-body">
        <div class="media" style="align-items: center">
          <div class="media-left" v-if="hasIcon && iconByType">
            <b-icon :icon="iconByType" both :type="type" size="is-large" />
          </div>
          <div class="media-content">
            <p>{{ message }}</p>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <b-button :loading="cancelling" @click="cancel">
          {{ cancelText }}
        </b-button>
        <b-button :type="type" :loading="confirming" @click="confirm">
          {{ confirmText }}
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    message: {
      type: String,
    },
    type: {
      type: String,
      default: "is-dark",
    },
    hasIcon: {
      type: Boolean,
      default: false,
    },
    confirmText: {
      type: String,
      default: "CONFIRM",
    },
    cancelText: {
      type: String,
      default: "CANCEL",
    },
    onConfirm: {},
    onCancel: {},
  },
  data: () => ({
    active: false,
    confirming: false,
    cancelling: false,
  }),
  computed: {
    iconByType() {
      switch (this.type) {
        case "is-info":
          return "info-circle";
        case "is-success":
          return "check-circle";
        case "is-warning":
          return "alert";
        case "is-danger":
          return "exclamation-circle";
        default:
          return null;
      }
    },
  },
  methods: {
    open() {
      this.active = true;
    },
    close() {
      this.active = false;
    },
    async confirm() {
      try {
        this.confirming = true;

        if (this.onConfirm) {
          await this.onConfirm();
        }

        this.$emit("confirm");
        this.close();
      } catch (err) {
        console.log(err);
        this.$emit("confirm-fail");
      } finally {
        this.confirming = false;
      }
    },
    async cancel() {
      try {
        this.cancelling = true;

        if (this.onCancel) {
          await this.onCancel();
        }

        this.$emit("cancel");
        this.close();
      } catch (err) {
        console.log(err);
        this.$emit("cancel-fail");
      } finally {
        this.cancelling = false;
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/partials/ModalConfirm.vue